const CheckPermission = (role, accessRole) => {
  const allPermission = JSON.parse(localStorage.getItem("pikgo-perm"));
  const findPermission = allPermission?.find((p) => p.obj == role);
  if (findPermission?.acts.find((a) => a.act == accessRole))
    return findPermission?.acts.find((a) => a.act == accessRole) ? true : false;
};

export default CheckPermission;
